import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-primary border-t border-gray-800" data-id="element-109">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8" data-id="element-110">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8" data-id="element-111">
          <div className="space-y-8 xl:col-span-1" data-id="element-112">
            <div data-id="element-113">
              <span className="text-2xl font-extrabold tracking-tight text-white" data-id="element-114">
                steward
              </span>
            </div>
            <p className="text-textlight text-base max-w-xs" data-id="element-115">
              The AI search optimization platform. Own your brand's visibility
              in the generative internet.
            </p>
            <div className="flex space-x-6" data-id="element-116">
              <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-117">
                <span className="sr-only" data-id="element-118">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-119">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-120" />
                </svg>
              </a>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-3 gap-8 xl:mt-0 xl:col-span-2" data-id="element-121">
            <div data-id="element-122">
              <h3 className="text-sm font-semibold text-white tracking-wider uppercase" data-id="element-123">
                Product
              </h3>
              <ul className="mt-4 space-y-4" data-id="element-124">
                <li data-id="element-125">
                  <Link to="/platform" className="text-base text-textlight hover:text-white transition-colors" data-id="element-126">
                    Features
                  </Link>
                </li>
                <li data-id="element-127">
                  <Link to="/platform" className="text-base text-textlight hover:text-white transition-colors" data-id="element-128">
                    AI Monitoring
                  </Link>
                </li>
                <li data-id="element-129">
                  <Link to="/platform" className="text-base text-textlight hover:text-white transition-colors" data-id="element-130">
                    Content Optimization
                  </Link>
                </li>
                <li data-id="element-131">
                  <Link to="/platform" className="text-base text-textlight hover:text-white transition-colors" data-id="element-132">
                    Analytics
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-133">
              <h3 className="text-sm font-semibold text-white tracking-wider uppercase" data-id="element-134">
                Company
              </h3>
              <ul className="mt-4 space-y-4" data-id="element-135">
                <li data-id="element-136">
                  <a href="/about" className="text-base text-textlight hover:text-white transition-colors" data-id="element-137">
                    About
                  </a>
                </li>
                <li data-id="element-138">
                  <a href="/careers" className="text-base text-textlight hover:text-white transition-colors" data-id="element-139">
                    Careers
                  </a>
                </li>
                <li data-id="element-140">
                  <a href="/blog" className="text-base text-textlight hover:text-white transition-colors" data-id="element-141">
                    Blog
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-142">
              <h3 className="text-sm font-semibold text-white tracking-wider uppercase" data-id="element-143">
                Legal
              </h3>
              <ul className="mt-4 space-y-4" data-id="element-144">
                <li data-id="element-145">
                  <a href="/" className="text-base text-textlight hover:text-white transition-colors" data-id="element-146">
                    Privacy
                  </a>
                </li>
                <li data-id="element-147">
                  <a href="/" className="text-base text-textlight hover:text-white transition-colors" data-id="element-148">
                    Terms
                  </a>
                </li>
                <li data-id="element-149">
                  <a href="/" className="text-base text-textlight hover:text-white transition-colors" data-id="element-150">
                    Cookie Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-800 pt-8" data-id="element-151">
          <p className="text-base text-textlight xl:text-center" data-id="element-152">
            &copy; {new Date().getFullYear()} Steward Technologies Inc. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;